import {Header} from '~/ViewInvitation/common/RSVPModalVariantAB/steps/components/Step/components/Header/Header';
import {Step} from '~/ViewInvitation/common/RSVPModalVariantAB/steps/components/Step/Step';
import {Button} from '~library/atoms/Button';
import {Typography} from '~library/atoms/Typography';

import './RSVPConfirmed.sass';

type RSVPConfirmed = {
  imageSrc: string;
  onCloseClick: () => void;
};

export const RSVPConfirmed = ({onCloseClick, imageSrc}: RSVPConfirmed) => (
  <Step
    header={<Header onClose={onCloseClick} />}
    footer={
      <Button
        variant="primary"
        size="large"
        data-qa-id="af-rsvp-view-invitation"
        onClick={onCloseClick}
        className="rsvp-step__footer__cta"
      >
        View Invitation
      </Button>
    }
    contentClassName="rsvp-confirmed"
  >
    <img
      className="rsvp-confirmed__image"
      src={imageSrc}
      alt="rsvp-confirmed-image"
      data-qa-id="rsvp-confirmed-image"
    />

    <Typography color="charcoal" variant="header3" className="rsvp-brut" semibold>
      Your RSVP is confirmed.
    </Typography>
  </Step>
);
